import { render, staticRenderFns } from "./appAdvertising.vue?vue&type=template&id=778dfd7a&scoped=true&"
import script from "./appAdvertising.vue?vue&type=script&lang=js&"
export * from "./appAdvertising.vue?vue&type=script&lang=js&"
import style0 from "./appAdvertising.vue?vue&type=style&index=0&id=778dfd7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778dfd7a",
  null
  
)

export default component.exports